<template>
  <div :class="$style.wrapper">
    <div :id="id" :class="$style.content"></div>
  </div>
</template>

<script>
const genRandomId = () => {
  return Math.random().toString(16).substr(2)
}

export default {
  name: 'sme-baidu-map',
  props: {
    id: {
      type: String,
      default: `baiduMap${genRandomId()}`
    },
    type: {
      type: String,
      default: 'show-point' // show-point, pick-point
    },
    level: {
      type: Number,
      default: 12
    },
    point: {
      type: Object,
      default: () => ({ lng: 116.414321, lat: 39.912345 }) // 北京市
    },
    isLocate: {
      type: Boolean,
      default: true
    },
    canWheelZoom: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '标题'
    },
    address: {
      type: String,
      default: '详细地址'
    },
    appKey: {
      type: String,
      default: ''
    }
  },

  mounted () {
    this.loadScript()
  },

  methods: {
    loadScript () {
      window.initializeBaiduMap = () => {
        this.initializeBaiduMap()
      }

      if (!window.BMap) {
        const script = document.createElement('script')
        script.src = `http://api.map.baidu.com/api?v=3.0&ak=${this.appKey}&callback=initializeBaiduMap`
        document.body.appendChild(script)
      } else {
        this.initializeBaiduMap()
      }
    },

    initializeBaiduMap () {
      const baiduMap = new window.BMap.Map(this.id)
      const point = new window.BMap.Point(this.point.lng, this.point.lat)

      baiduMap.centerAndZoom(point, this.level)

      if (this.canWheelZoom) { // 是否开启鼠标滚轮缩放
        baiduMap.enableScrollWheelZoom()
      } else {
        baiduMap.disableScrollWheelZoom()
      }

      baiduMap.addControl(new window.BMap.NavigationControl()) // 控制地图的平移和缩放的功能
      baiduMap.addControl(new window.BMap.ScaleControl()) // 默认位于地图左下方，显示地图的比例关系

      this.addMarker(baiduMap, point)

      if (this.isLocate) {
        this.getLocation(baiduMap)
      }

      if (this.type === 'pick-point') {
        this.addEvent(baiduMap)
      }
    },

    getLocation (baiduMap) {
      const localCity = new window.BMap.LocalCity()

      localCity.get((result) => {
        this.addMarker(baiduMap, result.center)
        this.$emit('select-point', result.center)
      })
    },

    addEvent (baiduMap) {
      baiduMap.addEventListener('click', (e) => {
        this.addMarker(baiduMap, e.point)
        this.$emit('select-point', e.point)
      })
    },

    addMarker (baiduMap, point) {
      const marker = new window.BMap.Marker(point) // 创建一个覆盖物

      baiduMap.clearOverlays() // 清除当前所有标注
      baiduMap.addOverlay(marker) // 增加一个标示到地图上
      baiduMap.panTo(point) // 飞到该点

      if (this.type === 'show-point') {
        this.addInfoPopover(baiduMap, marker, point)
      }
    },

    clearAllMarkers (baiduMap) {
      baiduMap.clearOverlays()
    },

    addInfoPopover (baiduMap, marker, point) {
      const options = {
        width: 0, // 信息窗口宽度，0：自动，区间：[220, 730]
        height: 0, // 信息窗口高度，0：自动，区间：[60, 650]
        title: `<b>${this.title}<b>` // 信息窗口标题
      }
      const infoWindow = new window.BMap.InfoWindow(this.address, options) // 创建信息窗口对象

      baiduMap.openInfoWindow(infoWindow, point)
      marker.addEventListener('click', () => {
        baiduMap.openInfoWindow(infoWindow, point) // 开启信息窗口
      })
    }
  }
}
</script>

<style module>
.wrapper {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
}
</style>
